export default [
  {
    title: 'ride_id',
    dataIndex: 'ride_id',
    key: 'ride_id',
  },
  {
    title: 'statement_core_id',
    dataIndex: 'statement_id',
    key: 'statement_id',
  },
  {
    title: 'ticket_number',
    dataIndex: 'ticket_number',
    key: 'ticket_number',
  },
  {
    title: 'ride_start_date_time',
    dataIndex: 'date_time',
    key: 'date_time',
  },
  {
    title: 'purchase_date',
    dataIndex: 'created_at',
    key: 'created_at',
  },
  {
    title: 'ticket_start_station',
    dataIndex: 'ticket_start_station',
    key: 'ticket_start_station',
  },
  {
    title: 'ticket_end_station',
    dataIndex: 'ticket_end_station',
    key: 'ticket_end_station',
  },
  {
    title: 'ticket_owner',
    dataIndex: 'ticket_owner',
    key: 'ticket_owner',
  },
  {
    title: 'customer_email',
    dataIndex: 'customer_email',
    key: 'customer_email',
  },
  {
    title: 'refunded',
    dataIndex: 'is_refunded',
    key: 'is_refunded',
  },
  {
    title: 'refund',
    dataIndex: 'refund',
    key: 'refund',
  },
];
